const SCIENTIFIC_PHONE = /^[+-]?\d+(?:\.\d+)?[eE][+-]?\d+$/;

export const digitsFromImportPhone = (
  raw: string | null | undefined,
): string => {
  if (raw == null) return '';
  const stripped = String(raw).trim().replace(/,/g, '');
  if (!stripped) return '';
  if (SCIENTIFIC_PHONE.test(stripped)) {
    const asInt = Math.trunc(Number(stripped));
    if (Number.isFinite(asInt) && asInt > 0) {
      return String(asInt);
    }
  }
  return stripped.replace(/\D/g, '');
};

export const normalizeImportPhone = (
  raw: string | null | undefined,
): string | null => {
  const digits = digitsFromImportPhone(raw);
  let national = '';
  if (digits.length === 10) {
    national = digits;
  } else if (digits.length === 11 && digits.startsWith('1')) {
    national = digits.slice(1);
  } else {
    return null;
  }
  if (national[0] === '0' || national[0] === '1') {
    return null;
  }
  return `+1${national}`;
};
